import type { Profile } from 'models';
import { useMemo } from 'react';
import type { NotificationsFormValues } from '../SettingsNotifications';
import { useBadgeNotificationSettings } from './useBadgeNotificationSettings';
import { useEmailNotificationSettings } from './useEmailNotificationSettings';
import { usePushNotificationSettings } from './usePushNotificationSettings';

export const useNotificationInitialValues = ({ viewer }: { viewer: Profile }): NotificationsFormValues => {
  const badgeNotificationsSettings = useBadgeNotificationSettings({ viewer });
  const emailNotificationsSettings = useEmailNotificationSettings({ viewer });
  const pushNotificationsSettings = usePushNotificationSettings({ viewer });

  return useMemo(
    () => ({
      badgeNotificationsSettings,
      emailNotificationsSettings,
      pushNotificationsSettings,
    }),
    [badgeNotificationsSettings, emailNotificationsSettings, pushNotificationsSettings],
  );
};
